import { styled } from '@linaria/react';
import { PaginationButton } from '../shared/Button.styles';

export const ProductHeaderWrapper = styled.div`
    padding: 0;
    margin-bottom: 1rem;

    @media print {
        margin-bottom: 0.5rem;
    }
`;

export const NavigationBar = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 1rem;

    @media (max-width: 768px) {
        flex-wrap: wrap;
        gap: 0.5rem;
    }

    @media print {
        display: none !important;
    }
`;

export const BackButton = PaginationButton;
export const PrintButton = styled(PaginationButton)`
    @media (max-width: 768px) {
        display: none;
    }
`;

export const SplitViewButton = styled(PaginationButton)`
    @media (max-width: 1280px) {
        display: none;
    }
`;

export const CategoryButton = PaginationButton;

export const NavButtonGroup = styled.div`
    display: flex;
    align-items: center;
    gap: 0.5rem;
`;

export const ProductTitleSection = styled.div``;

export const ProductTitleRow = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 0.5rem;

    @media (max-width: 768px) {
        flex-direction: column;
        align-items: flex-start;
        gap: 0.5rem;
    }
`;

export const TitleLeft = styled.div`
    display: flex;
    align-items: center;
    gap: 1rem;
    flex: 0 0 70%;
    max-width: 70%;

    @media (max-width: 768px) {
        flex: 1 1 auto;
        max-width: 100%;
    }
`;

export const TitleRight = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 1rem;
    flex: 0 0 30%;
    max-width: 30%;

    @media (max-width: 768px) and (pointer: coarse) {
        flex: 1 1 auto;
        max-width: 100%;
        justify-content: flex-start;
        flex-wrap: wrap;
        gap: 0.5rem;
    }
`;

export const ProductHeadingTitle = styled.div<{ $longTitle?: boolean }>`
    font-size: ${props => props.$longTitle ? '1.2rem' : '1.6rem'};
    font-weight: 700;
    color: #2c3e50;
    word-wrap: break-word;
    overflow-wrap: break-word;
    hyphens: auto;
    line-height: 1.2;

    .default-product-label {
        color: #6c757d;
        font-weight: 400;
        font-size: ${props => props.$longTitle ? '0.85rem' : '1rem'};
    }

    @media (max-width: 768px) {
        font-size: ${props => props.$longTitle ? '1rem' : '1.1rem'};

        .default-product-label {
            font-size: 0.75rem;
        }
    }
`;

export const ProductSymbolsRow = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-end;

    @media (max-width: 768px) {
        font-size: 0.75rem;
    }
`;

export const ButtonGroup = styled.div`
    display: flex;
    align-items: center;
    gap: 0.5rem;

    @media (max-width: 768px) {
        flex-wrap: wrap;
    }
`;
